import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import Cookies from 'js-cookie';
import axios from 'axios';
import Topbar from '../layouts/Topbar';
import Sidebar from '../layouts/Sidebar';
import { toast } from 'react-toastify';
import '../../HR Manager/screens/EmployeeGoals.css';
import { FaPlus, FaTrash } from 'react-icons/fa';
import API_BASE_URL from '../../../config/api';

const quarterOptions = [
  { value: 'Q1', label: 'Quarter 1' },
  { value: 'Q2', label: 'Quarter 2' },
  { value: 'Q3', label: 'Quarter 3' },
  { value: 'Q4', label: 'Quarter 4' }
];

const CreateBulkGoals = () => {
  const baseUrl = API_BASE_URL
  const [kras, setKras] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formList, setFormList] = useState([
    { key_result_area: null, activity: '', metric: '', stakeholder: '', quarter: null }
  ]);

  useEffect(() => {
    const fetchKRAs = async () => {
      try {
        const token = Cookies.get('token');
        const response = await axios.get(`${baseUrl}/api/key-result-areas/`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        setKras(response.data);
      } catch (err) {
        toast.error('Failed to fetch Key Result Areas.');
      }
    };
    fetchKRAs();
  }, []);

  const kraOptions = kras.map(kra => ({ value: kra.id, label: kra.name }));

  const handleChange = (idx, e) => {
    const { name, value } = e.target;
    setFormList(list => list.map((item, i) => i === idx ? { ...item, [name]: value } : item));
  };

  const handleSelectChange = (idx, selected, { name }) => {
    setFormList(list => list.map((item, i) => i === idx ? { ...item, [name]: selected } : item));
  };

  const handleAdd = () => {
    setFormList(list => [...list, { key_result_area: null, activity: '', metric: '', stakeholder: '', quarter: null }]);
  };

  const handleRemove = (idx) => {
    setFormList(list => list.length > 1 ? list.filter((_, i) => i !== idx) : list);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = Cookies.get('token');
      const currentYear = new Date().getFullYear();
      const payload = formList.map(goal => ({
        key_result_area_id: goal.key_result_area?.value,
        activity: goal.activity,
        metric: parseInt(goal.metric),
        stakeholder: goal.stakeholder,
        quarter: goal.quarter?.value,
        year: currentYear
      }));
      await axios.post(`${baseUrl}/api/goals/bulk-create/`, payload, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      toast.success('KPIs created successfully!');
      setFormList([{ key_result_area: null, activity: '', metric: '', stakeholder: '', quarter: null }]);
    } catch (err) {
      console.log(err)
      toast.error(err.response?.data?.details[0]?.error.non_field_errors[0] || 'Failed to create KPIs.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <div className="employee-goals-container" style={{ minHeight: '100vh', background: '#f8fafc', padding: '40px 0' }}>
        <div className="goals-table-wrapper" style={{ maxWidth: 900,minHeight: '100vh', margin: '0 auto', padding: 24 }}>
          <h2 style={{ fontWeight: 700, fontSize: 28, marginBottom: 24, color: '#1e293b' }}>Create Bulk KPIs</h2>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            {formList.map((goal, idx) => (
              <div key={idx} style={{
                background: '#fff',
                borderRadius: 12,
                boxShadow: '0 1px 4px rgba(0,0,0,0.03)',
                padding: 10,
                marginBottom: 10,
                display: 'flex',
                flexDirection: 'column',
                gap: 6,
              }}>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
                  <div style={{ minWidth: 180, flex: 1 }}>
                    <Select
                      name="key_result_area"
                      value={goal.key_result_area}
                      onChange={(selected, action) => handleSelectChange(idx, selected, action)}
                      options={kraOptions}
                      placeholder="KRA"
                      classNamePrefix="react-select"
                      required
                      styles={{ control: base => ({ ...base, minHeight: 36, borderRadius: 6, fontSize: 15 }) }}
                    />
                  </div>
                  <div style={{ minWidth: 120, flex: 1 }}>
                    <Select
                      name="quarter"
                      value={goal.quarter}
                      onChange={(selected, action) => handleSelectChange(idx, selected, action)}
                      options={quarterOptions}
                      placeholder="Quarter"
                      classNamePrefix="react-select"
                      required
                      styles={{ control: base => ({ ...base, minHeight: 36, borderRadius: 6, fontSize: 15 }) }}
                    />
                  </div>
                  <div style={{ minWidth: 100, flex: 1 }}>
                    <input
                      type="number"
                      name="metric"
                      value={goal.metric}
                      onChange={e => handleChange(idx, e)}
                      required
                      className="form-input"
                      placeholder="Metric"
                      min="0"
                      style={{ borderRadius: 6, border: '2px solid #e5e7eb', fontSize: 15, padding: '8px 10px', width: '100%' }}
                    />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', marginTop: 4 }}>
                  <div style={{ minWidth: 160, flex: 1 }}>
                    <input
                      type="text"
                      name="stakeholder"
                      value={goal.stakeholder}
                      onChange={e => handleChange(idx, e)}
                      required
                      className="form-input"
                      placeholder="Stakeholder"
                      style={{ borderRadius: 6, border: '2px solid #e5e7eb', fontSize: 15, padding: '8px 10px', width: '100%' }}
                    />
                  </div>
                  <div style={{ minWidth: 220, flex: 2 }}>
                    <input
                      type="text"
                      name="activity"
                      value={goal.activity}
                      onChange={e => handleChange(idx, e)}
                      required
                      className="form-input"
                      placeholder="Activity"
                      style={{ borderRadius: 6, border: '2px solid #e5e7eb', fontSize: 15, padding: '8px 10px', width: '100%' }}
                    />
                  </div>
                  <div style={{ minWidth: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <button
                      type="button"
                      className="icon-button"
                      style={{ background: 'none', border: 'none', color: '#ef4444', fontSize: 20, cursor: 'pointer', padding: 4 }}
                      onClick={() => handleRemove(idx)}
                      disabled={formList.length === 1}
                      title="Remove"
                    >
                      <FaTrash />
                    </button>
                  </div>
                </div>
              </div>
            ))}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 10 }}>
              <button
                type="button"
                className="icon-button"
                style={{ background: 'linear-gradient(135deg,rgb(34, 16, 232) 0%,rgb(235, 235, 242) 100%)', color: '#fff', borderRadius: '50%', padding: 10, fontWeight: 700, fontSize: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', width: 44, height: 44, boxShadow: '0 2px 8px rgba(34,197,94,0.08)' }}
                onClick={handleAdd}
                title="Add More"
              >
                <FaPlus />
              </button>
              <button
                type="submit"
                className="submit-button"
                style={{ background: 'linear-gradient(135deg,rgb(190, 211, 246) 0%,rgb(23, 40, 223) 100%)', color: '#fff', borderRadius: 8, padding: '8px 18px', fontWeight: 700, fontSize: 15, width: '40%' }}
                disabled={loading}
              >
                {loading ? 'Creating...' : 'Create All'}
              </button>
            </div>
          </form>
        </div>
        <style>{`
          .icon-button:disabled { opacity: 0.5; cursor: not-allowed; }
          @media (max-width: 1100px) {
            .goals-table-wrapper { padding: 8px !important; }
          }
          @media (max-width: 900px) {
            .goals-table-wrapper { padding: 2px !important; }
            form > div { flex-direction: column !important; gap: 8px !important; }
          }
        `}</style>
      </div>
    </>
  );
};

export default CreateBulkGoals;
